import { motion } from 'framer-motion';
import { Dumbbell, Timer, Flame, TrendingUp } from 'lucide-react';

// Smooth ease-out used across the dashboard stagger so cards rise in with a
// consistent, premium cadence. Tightened delays from 100-400ms to 80-260ms
// so the whole grid finishes settling before the user can scroll.
const STAGGER_EASE = [0.16, 1, 0.3, 1];

const statsConfig = [
  { key: 'total_workouts', label: 'Total', desc: 'Workouts Completed', Icon: Dumbbell, delay: 0.08 },
  { key: 'total_minutes', label: 'Time', desc: 'Minutes Trained', Icon: Timer, delay: 0.14 },
  { key: 'total_calories', label: 'Burned', desc: 'Calories Burned', Icon: Flame, delay: 0.20, format: (v) => (v || 0).toLocaleString() },
  { key: 'current_streak', label: 'Streak', desc: 'Day Streak', Icon: TrendingUp, delay: 0.26 },
];

export const StatsGrid = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 mb-6">
    {statsConfig.map(({ key, label, desc, Icon, delay, format }) => (
      <motion.div
        key={key}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay, duration: 0.5, ease: STAGGER_EASE }}
        className="bg-card border border-border rounded-xl p-3 card-hover"
        data-testid={`stat-${key}`}
      >
        <div className="flex items-center justify-between mb-1.5">
          <Icon className="h-5 w-5 text-primary" />
          <span className="text-[10px] text-muted-foreground uppercase tracking-wider">{label}</span>
        </div>
        <p className="font-heading text-2xl text-white leading-tight">
          {format ? format(stats?.[key]) : (stats?.[key] || 0)}
        </p>
        <p className="text-muted-foreground text-xs leading-tight mt-0.5">{desc}</p>
      </motion.div>
    ))}
  </div>
);
